module.exports = __webpack_public_path__ + "images/anwbassurantien1d650cbf6da0623f78e5ff3b8052fd66.png";